import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import Input from "../input/Input";
import { Dropdown } from "primereact/dropdown";
import Label from "../other/label";
import AddressInput from "../input/AddressInput";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "primereact/image";
import ApiBaseURLProps from "../other/apiBaseURL";
import {
  setFirstName,
  setMiddleName,
  setLastName,
  setRelationship,
  setCountry,
  setState,
  setDistrict,
  setMunicipality,
  setWard,
  setTole,
  setBlockNo,
  setTelephoneNo,
  setEmailId,
  setMobileNo,
  setFax,
  setRelationshipDesc,
  setCountryDesc,
  setStateDesc,
  setDistrictDesc,
  setMunicipalityDesc,
  setRelationshipOthers,
  setGuardianDocumentValue,
  appendGuardianAddressData,
  setPan,
  setFirstNameNep,
  setMiddleNameNep,
  setLastNameNep,
  setFirstNameError,
  setMiddleNameError,
  setLastNameError,
  setGRelationshipError,
  setGRelationshipOthersError,
} from "../../redux/guardianSlice";
import { useState, useEffect } from "react";
import ApiService from "../service/apiService";
import { useForm, Controller } from "react-hook-form";
import { NextButton, PrevButton } from "./kycSidebar";
import { classNames } from "primereact/utils";
import { DynamicFieldSection } from "./personalDetails";
import { SaveButton } from "./declerationDetails";
import { DocumentUpload, filterDocument } from "./documentDetails";
import InputText from "../other/InputText";
import {
  setDocumentTypeList,
  setDocumentValue,
} from "../../redux/documentSlice";
import FileUploadComponent from "../other/fileUploadComponent";
import { getTValue } from "../other/label";
import { InputMask } from "primereact/inputmask";
import PhoneInput from "react-phone-input-2";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import NepaliDatePicker2 from "../other/nepaliDatePicker";
import { setDocIdError } from "../../redux/occupationSlice";
import AdBsDatePicker from "../other/adBsDatePicker";
import { alphabetChecker, validateNameField } from "../../helper/validationHelper";

const footer = () => (
  <div class=" p-field p-col-12 p-md-12">
    <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
      <div style={{ flex: 1 }}>
        <PrevButton />
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <SaveButton style={{ flex: 1 }} />
        </center>
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <NextButton />
        </center>
      </div>
    </div>
  </div>
);


function GuardianDetails() {
  const { t, i18n } = useTranslation();
  const firstName = useSelector((state) => state.guardianDetails.firstName);
  const middleName = useSelector((state) => state.guardianDetails.middleName);
  const lastName = useSelector((state) => state.guardianDetails.lastName);
  const firstNameNep = useSelector((state) => state.guardianDetails.firstNameNep);
  const middleNameNep = useSelector((state) => state.guardianDetails.middleNameNep);
  const lastNameNep = useSelector((state) => state.guardianDetails.lastNameNep);
  const relationship = useSelector(
    (state) => state.guardianDetails.relationship
  );
  const pan = useSelector((state) => state.guardianDetails.pan);
  const country = useSelector((state) => state.guardianDetails.country);
  const state = useSelector((state) => state.guardianDetails.state);
  const district = useSelector((state) => state.guardianDetails.district);
  const municipality = useSelector(
    (state) => state.guardianDetails.municipality
  );
  const guardianDetails = useSelector((state) => state.guardianDetails);
  const ward = useSelector((state) => state.guardianDetails.ward);
  const tole = useSelector((state) => state.guardianDetails.tole);
  const blockNo = useSelector((state) => state.guardianDetails.blockNo);
  const telephoneNo = useSelector((state) => state.guardianDetails.telephoneNo);
  const emailId = useSelector((state) => state.guardianDetails.emailId);
  const mobileNo = useSelector((state) => state.guardianDetails.mobileNo);
  const fax = useSelector((state) => state.guardianDetails.fax);
  const relationshipDesc = useSelector(
    (state) => state.guardianDetails.relationshipDesc
  );
  const countryDesc = useSelector((state) => state.guardianDetails.countryDesc);
  const stateDesc = useSelector((state) => state.guardianDetails.stateDesc);
  const districtDesc = useSelector(
    (state) => state.guardianDetails.districtDesc
  );
  const municipalityDesc = useSelector(
    (state) => state.guardianDetails.municipalityDesc
  );
  const [loadingr, setLoadingr] = useState(false);
  // const firstNameError = useSelector(
  //   (state) => state.guardianDetails.firstNameError
  // );
  // const lastNameError = useSelector(
  //   (state) => state.guardianDetails.lastNameError
  // );
  // const relationshipError = useSelector(
  //   (state) => state.guardianDetails.relationshipError
  // );
  // const countryError = useSelector(
  //   (state) => state.guardianDetails.countryError
  // );
  // const stateError = useSelector((state) => state.guardianDetails.stateError);
  // const districtError = useSelector(
  //   (state) => state.guardianDetails.districtError
  // );
  // const municipalityError = useSelector(
  //   (state) => state.guardianDetails.municipalityError
  // );
  // const wardError = useSelector((state) => state.guardianDetails.wardError);
  // const toleError = useSelector((state) => state.guardianDetails.toleError);
  // const emailIdError = useSelector(
  //   (state) => state.guardianDetails.emailIdError
  // );
  // const mobileNoError = useSelector(
  //   (state) => state.guardianDetails.mobileNoError
  // );
  // const telephoneNoError = useSelector(
  //   (state) => state.guardianDetails.telephoneNoError
  // );
  // const faxError = useSelector((state) => state.guardianDetails.faxError);

  const errorObj = useSelector((state) => state.guardianDetails.errors);
  let {
    firstNameError,
    lastNameError,
    middleNameError,
    firstNameNepError,
    lastNameNepError,
    relationshipError,
    countryError,
    stateError,
    districtError,
    municipalityError,
    wardError,
    toleError,
    emailIdError,
    mobileNoError,
    telephoneNoError,
    faxError,
    docIdError,
    issuedDateError,
    issuedDateBsError,
    issuedFromError,
    fileIdError,
    backFileIdError,
    panError,
  } = {};
  if (errorObj && errorObj.firstNameError) {
    firstNameError = errorObj.firstNameError.message;
  }
  if (errorObj && errorObj.lastNameError) {
    lastNameError = errorObj.lastNameError.message;
  }

  if (errorObj && errorObj.firstNameNepError) {
    firstNameNepError = errorObj.firstNameNepError.message;
  }
  if (errorObj && errorObj.lastNameNepError) {
    lastNameNepError = errorObj.lastNameNepError.message;
  }
  if (errorObj && errorObj.relationshipError) {
    relationshipError = errorObj.relationshipError.message;
  }
  if (errorObj && errorObj.countryError) {
    countryError = errorObj.countryError.message;
  }
  if (errorObj && errorObj.stateError) {
    stateError = errorObj.stateError.message;
  }
  if (errorObj && errorObj.districtError) {
    districtError = errorObj.districtError.message;
  }
  if (errorObj && errorObj.municipalityError) {
    municipalityError = errorObj.municipalityError.message;
  }
  if (errorObj && errorObj.wardError) {
    wardError = errorObj.wardError.message;
  }
  if (errorObj && errorObj.toleError) {
    toleError = errorObj.toleError.message;
  }
  if (errorObj && errorObj.emailIdError) {
    emailIdError = errorObj.emailIdError.message;
  }
  if (errorObj && errorObj.mobileNoError) {
    mobileNoError = errorObj.mobileNoError.message;
  }
  if (errorObj && errorObj.telephoneNoError) {
    telephoneNoError = errorObj.telephoneNoError.message;
  }
  if (errorObj && errorObj.faxError) {
    faxError = errorObj.faxError.message;
  }
  if (errorObj && errorObj.docIdError) {
    docIdError = errorObj.docIdError.message;
  }
  if (errorObj && errorObj.issuedDateError) {
    issuedDateError = errorObj.issuedDateError.message;
  }
  if (errorObj && errorObj.issuedDateBsError) {
    issuedDateBsError = errorObj.issuedDateBsError.message;
  }
  if (errorObj && errorObj.issuedFromError) {
    issuedFromError = errorObj.issuedFromError.message;
  }
  if (errorObj && errorObj.fileIdError) {
    fileIdError = errorObj.fileIdError.message;
  }
  if (errorObj && errorObj.backFileIdError) {
    backFileIdError = errorObj.backFileIdError.message;
  }
  if (errorObj && errorObj.panError) {
    panError = errorObj.panError.message;
  }

  const relationshipOthers = useSelector(
    (state) => state.guardianDetails.relationshipOthers
  );

  const dispatch = useDispatch();

  const [relationTypeList, setRelationTypeList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [municipalityList, setMunicipalityList] = useState([]);
  const [wardList, setWardList] = useState([]);
  const [issuedFromList, setIssuedFromList] = useState([]);



  const [docId, setDocId] = useState();
  const [issuedFrom, setIssuedFrom] = useState();
  const [issuedFromDesc, setIssuedFromDesc] = useState();
  const [issuedDate, setIssuedDate] = useState();
  const [issuedDateBs, setIssuedDateBs] = useState();
  const [documentMetadata, setDocumentMetadata] = useState({});

  function isValidDate(date) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!date.match(regEx)) return false; // Invalid format
    var d = new Date(date);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === date;
  }




  const maritalStatus = useSelector((state) => state.personalDetails.maritalStatus);



  useEffect(() => {
    setLoadingr(true)
    ApiService.getRelationTypeList().then((response) => {
      const nRelation = response && response.data && response.data.data;
      const nRelationList = nRelation.filter(p => p.maritalStatus == null || p.maritalStatus === maritalStatus);
      setRelationTypeList(nRelationList);
    }).finally(() => setLoadingr(false));

    ApiService.getCountryList().then((response) => {
      console.log(response.data);
      setCountryList(response.data.data);
      console.log(countryList);
      if (country) {
        getStateListByCountryCode(country);
      }
    });
  }, [maritalStatus]);

  useEffect(() => {
    if (state) getDistrictListByStateCode(state);
  }, [state]);

  useEffect(() => {
    if (municipality) {
      const mun = municipalityList.find((m) => m.code === municipality);
      if (mun && mun.ward) setWardList(getWard(mun.ward));
    }
  }, [municipality]);

  function getStateListByCountryCode(param) {
    console.log("param", param);
    ApiService.getStateListByCountryCode(param).then((response) => {
      console.log(response.data);
      setStateList(response.data.data);
      if (state) {
        getDistrictListByStateCode(state);
      }
      console.log(stateList);
    });
  }

  function getDistrictListByStateCode(param) {
    ApiService.getDistrictListByStateCode(param).then((response) => {
      console.log(response.data);
      setDistrictList(response.data.data);
      if (district) {
        getMunicipalityListByDistrictCode(district);
      }
    });
  }

  function getMunicipalityListByDistrictCode(param) {
    ApiService.getMunicipalityListByDistrictCode(param).then((response) => {
      console.log(response.data);
      setMunicipalityList(response.data.data);
      if (municipality) {
        const mun = response.data.data.find((m) => m.code === municipality);
        if (mun && mun.ward) setWardList(getWard(parseInt(mun.ward)));
      }
    });
  }

  function getWard(totalWard) {
    const wardList = [];
    for (let i = 1; i <= totalWard; i++) {
      wardList.push(i);
    }
    console.log("wardlist", wardList);
    // setWardList(wardList);
    return wardList;
  }

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const documentTypeList = useSelector(
    (state) => state.documentDetails.documentTypeList
  );
  const documentType = documentTypeList.find((d) => d.code === "PH") || {};

  const guardianDocumentList = useSelector(
    (state) => state.guardianDetails.guardianDocumentList
  );

  useEffect(() => {
    if (!documentTypeList.length)
      ApiService.getDocumentTypeList().then((response) => {
        console.log("doc", response);
        dispatch(setDocumentTypeList(response.data.data));
      });
  }, []);

  const photo =
    guardianDocumentList.find((d) => d.documentTypeId === "PH") || {};

  useEffect(() => {
    if (guardianDocumentList.length) {
      let dType = guardianDocumentList
        .find((p) => p.documentTypeId == "GCZ");
      if (dType && dType.documentMetadata && dType.documentMetadata.length) {
        const docMapData = dType.documentMetadata.reduce((a, v) => {
          a[v.docField] = v;
          return a;
        }, {});
        setDocumentMetadata(docMapData);
      }
    }
    ApiService.getDistrictList().then((response) => {
      setIssuedFromList(response.data.data);
    });

  }, []);



  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-shield" /> {t("guardianDetails")}
        </h3>
      }
      footer={footer}
    >
      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>
        <div
          className="p-field p-col-12 p-md-12"
        >
          <FileUploadComponent
            type="userPhoto"
            data={{ ...photo, ...documentType }}
            onUpload={(data) => {
              dispatch(
                setGuardianDocumentValue({
                  code: "PH",
                  key: "fileId",
                  value: data.storageFileName,
                })
              );
            }}
          />
        </div>
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="name">
            {t("nameSurname")}
          </label>
          <div className="p-inputgroup">
            {/* <Controller
              name="firstName"
              control={control}
              rules={{ required: "First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter="alpha"
                  placeholder={t("fName")}
                  onChange={(e) => dispatch(setFirstName(e.target.value))}
                  value={firstName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            /> */}
            <Controller
              name="firstName"
              control={control}
              rules={{ required: "First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  placeholder={t("fName")}
                  keyfilter={/^[a-zA-Z .]*$/}
                  isName
                  onChange={(e) => {
                    dispatch(setFirstName(e.target.value));
                    field.onChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    // Use dynamic validation helper for firstName
                    validateNameField(e.target.value, "First Name", dispatch, setFirstNameError, setFirstNameError, firstName, "Valid First Name is required");
                  }}
                  value={firstName}
                  className={classNames({
                    //  "p-invalid": fieldState.invalid 
                    // "p-invalid": fieldState.invalid || firstNameError,
                    "p-invalid": fieldState.invalid || firstNameError?.message,
                  })}
                />
              )}
            />
            {getFormErrorMessage("firstName")}
            {/* <Controller
              name="middleName"
              control={control}
              rules={{ required: "Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  placeholder={t("mName")}
                  clearSpace
                  keyfilter={/^[a-zA-Z ]*$/}
                  onChange={(e) => dispatch(setMiddleName(e.target.value))}
                  value={middleName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            /> */}
            <Controller
              name="middleName"
              control={control}
              rules={{ required: "Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("mName")}
                  onChange={(e) => {
                    dispatch(setMiddleName(e.target.value));

                    field.onChange(e.target.value);
                  }}
                  // value={middleName}
                  // className={classNames({ "p-invalid": fieldState.invalid })}
                  onBlur={(e) => {
                    validateNameField(e.target.value, "Middle Name", dispatch, setMiddleNameError, setMiddleNameError, middleName, "Valid Middle Name is required");
                  }}
                  value={middleName}
                  className={classNames({
                    "p-invalid": fieldState.invalid || middleNameError?.message,
                  })}
                />
              )}
            />
            {getFormErrorMessage("middleName")}
            {/* <Controller
              name="lastName"
              control={control}
              rules={{ required: "Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) => dispatch(setLastName(e.target.value))}
                  value={lastName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            /> */}
            <Controller
              name="lastName"
              control={control}
              rules={{ required: "Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) => {
                    dispatch(setLastName(e.target.value));
                    field.onChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    // Use dynamic validation helper for lastName
                    validateNameField(e.target.value, "Last Name", dispatch, setLastNameError, setLastNameError, lastName, "Valid Last Name is required");
                  }}
                  value={lastName}
                  className={classNames({
                    // "p-invalid": fieldState.invalid
                    "p-invalid": fieldState.invalid || lastNameError?.message,
                  })}
                />
              )}
            />
            {getFormErrorMessage("lastName")}
          </div>
        </div>
        {getFormErrorMessage("firstName")}
        {getFormErrorMessage("middleName")}
        {getFormErrorMessage("lastName")}
        <span style={{ color: "red" }}>{firstNameError}</span>
        <span style={{ color: "red", marginLeft: 450 }}>{lastNameError}</span>
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="nameNep">
            {t("nameNepali")}*
          </label>
          <div className="p-inputgroup">
            <InputText
              placeholder={t("fName")}
              value={firstNameNep}
              keyfilter="alpha"
              convertToNepali
              onChange={(e) => {
                dispatch(setFirstNameNep(e.value));
              }}
            />
            <InputText
              placeholder={t("mName")}
              isName
              keyfilter={/^[a-zA-Z ]*$/}
              value={middleNameNep}
              convertToNepali
              onChange={(e) => {
                dispatch(setMiddleNameNep(e.value));
              }}
            />
            <InputText
              placeholder={t("lName")}
              value={lastNameNep}
              keyfilter={/^[a-zA-Z .]*$/}
              isName
              convertToNepali
              onChange={(e) => {
                dispatch(setLastNameNep(e.value));
              }}
            />
          </div>
          <span style={{ color: "red" }}>{firstNameNepError}</span>
          {firstNameNepError && lastNameNepError && <br />}
          <span style={{ color: "red" }}>{lastNameNepError}</span>
        </div>

        <div className="p-field p-col-12 p-md-8 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="relationship">
            {t("applicantRelationship")}
          </label>
          <Controller
            name="relationship"
            control={control}
            rules={{ required: "Relation Type is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={relationship}
                filter showClear
                disabled={loadingr}
                dropdownIcon={loadingr ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  console.log(e);
                  console.log("f", field);
                  field.onChange(e.value);
                  dispatch(setRelationship(e.value));
                  dispatch(
                    setRelationshipDesc(
                      e.originalEvent.nativeEvent.target.ariaLabel
                    )
                  );
                  if (e.value !== "O") {
                    dispatch(setRelationshipOthers(null));
                  }
                }}
                // onBlur={(e) => {
                //   const value = guardianDetails?.relationship;
                //   // antiMoneyLaundering?.relationshipError;
                //   if (!value) {
                //     dispatch(setGRelationshipError({
                //       message: "Relation with applicant can't be empty.",
                //       section: "GD",
                //     }));
                //   } else {
                //     dispatch(setGRelationshipError({
                //       message: null,
                //       section: "GD",
                //     }));
                //   }
                // }}
                options={relationTypeList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectRelationship")}
                optionValue="code"
              />
            )}
          />
        </div>
        {getFormErrorMessage("relationship")}
        <span style={{ color: "red" }}>{relationshipError}</span>
        {/* <span style={{ color: "red", marginLeft: "-37%", paddingTop: "9%" }}>{relationshipError}</span> */}
        {relationship === "O" ? (
          <>
            <div className="p-field p-col-12 p-md-4 stick-left">
              <label className="p-col-12 p-md-8" htmlFor="otherRelationship">
                {t("relationshipOthers")}
              </label>
              <div className="p-inputgroup">
                <Input
                  value={relationshipOthers}
                  onChange={(e) => {
                    dispatch(setRelationshipOthers(e.target.value));
                  }}
                  // onBlur={(e) => {
                  //   const value = e.target.value.trim(); // Trim to handle whitespace-only values
                  //   if (!value) {
                  //     dispatch(setGRelationshipError({
                  //       message: "Relation with applicant Others can't be empty.",
                  //       section: "GD",
                  //     }));
                  //   }
                  //   else if (!alphabetChecker(value)) {
                  //     dispatch(setGRelationshipError({
                  //       message: "Relation with applicant others should be in alphabet characters only.",
                  //       section: "GD",
                  //     }));
                  //   }
                  //   else {
                  //     dispatch(setGRelationshipError({
                  //       message: null,
                  //       section: "GD",
                  //     }));
                  //   }
                  // }}
                  placeholder={t("relationshipOthers")}
                />
              </div>
            </div>
          </>
        ) : null}

        <div className="p-field p-col-12 p-md-4 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="pan">
            {t("pan")}
          </label>
          <InputMask
            value={pan}
            onChange={(e) => {
              dispatch(setPan(e.target.value));
            }}
            onBlur={() => {
              {
                // console.log("KycPan",kycPan);
                // getPanDetails();
                // console.log("data",user,kyc)                
              }
            }}
            mask="999999999"
            placeholder={t("pan")}
          />
        </div>
        <span style={{ color: "red" }}>{panError}</span>
        {getFormErrorMessage("pan")}
        <h4
          className="p-col-12 p-md-12"
          style={{ paddingTop: 10, textAlign: "center" }}
        >
          <u>{t("correspondenceAddress")}</u>
        </h4>

        <AddressInput
          errorObj={errorObj}
          hide={{ website: true }}
          data={guardianDetails}
          onChange={data => {
            dispatch(appendGuardianAddressData(data));
          }} />

        <h4 className="p-col-12 p-md-12">
          <p className="section-title">{t("documentUpload")}</p>
        </h4>
        {guardianDocumentList
          .filter((p) => p.documentTypeId !== "PH")
          .map((p) => (
            <div className="p-col-12 p-md-12">
              {p.documentTypeDesc}:
              {(p.documentTypeId === 'GCZ' || p.documentTypeId === 'GNID') && <div className="p-grid p-fluid">
                <div className={
                  "p-field p-col-12 p-md-4 stick-right"
                }
                >
                  <label className="p-col-12 p-md-12" htmlFor="docId">
                    {/* {['GNID'].includes(p.documentTypeId) ? "National Identification Number" : t("docId")} */}
                    {t("docId")} *
                  </label>
                  <Controller
                    name="docId"
                    control={control}
                    rules={{ required: "Document Id is required." }}
                    render={({ field, fieldState }) => (
                      <div className="p-inputgroup">
                        {/* <InputText
                          id={field.name}
                          {...field}
                          value={p.docId}
                          clearSpace
                          keyFilter="alphanum"
                          placeholder={['NID', 'GNID'].includes(p.documentTypeId) ? "National Identification Number" : t("docId")}

                          onChange={(e) => {
                            field.onChange(e.target.value);
                            // setDocId(e.target.value);\
                            setDocIdError("");
                            dispatch(
                              setGuardianDocumentValue({
                                code: p.documentTypeId,
                                key: "docId",
                                value: e.target.value,
                              })
                            );
                          }}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        /> */}
                        {['GNID'].includes(p.documentTypeId) ? (
                          <InputMask
                            value={p.docId || ''}
                            mask="9999999999"
                            placeholder="National Identification Number"
                            unmask={true}
                            onChange={(e) => {
                              const value = e.target.value || '';
                              field.onChange(value);
                              setDocIdError("");
                              dispatch(
                                setGuardianDocumentValue({
                                  code: p.documentTypeId,
                                  key: "docId",
                                  value: value,
                                })
                              );
                            }}
                            className={classNames({ "p-invalid": fieldState.invalid })}
                          />
                        ) : (
                          <InputText
                            id={field.name}
                            {...field}
                            value={p.docId}
                            clearSpace
                            keyFilter="alphanum"
                            placeholder={t("docId")}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              setDocIdError("");
                              dispatch(
                                setGuardianDocumentValue({
                                  code: p.documentTypeId,
                                  key: "docId",
                                  value: e.target.value,
                                })
                              );
                            }}
                            className={classNames({ "p-invalid": fieldState.invalid })}
                          />
                        )}
                      </div>
                    )}
                  />
                  <span style={{ color: "red" }}>
                    {p.documentTypeId === 'GCZ' && docIdError && docIdError.includes("Citizenship") ? docIdError : null}
                    {['GNID'].includes(p.documentTypeId) && docIdError ? docIdError : null}
                  </span>
                  {getFormErrorMessage("docId")}
                </div>

                {!['GNID'].includes(p.documentTypeId) && <Controller
                  name="issuedDate"
                  control={control}
                  rules={{ required: "Issued Date is required." }}
                  render={({ field, fieldState }) => (
                    <AdBsDatePicker
                      label={t("issuedDate")}
                      bsDate={p.issuedDateBs}
                      adDate={p.issuedDate}
                      adError={issuedDateBsError}

                      getFormErrorMessageAd={getFormErrorMessage('issuedDate')}
                      getFormErrorMessageBs={getFormErrorMessage('issuedDateBs')}
                      onChange={(adDate, bsDate, extra) => {
                        field.onChange(
                          adDate
                        );
                        // setIssuedDateBs(bsDate);
                        dispatch(
                          setGuardianDocumentValue({
                            code: p.documentTypeId,
                            key: "issuedDateBs",
                            value: bsDate,
                          })
                        );
                        // setIssuedDate(adDate);
                        dispatch(
                          setGuardianDocumentValue({
                            code: p.documentTypeId,
                            key: "issuedDate",
                            value: adDate,
                          })
                        );

                      }} />

                  )}
                />}
                {!['GNID'].includes(p.documentTypeId) && <div className="p-field p-col-12 p-md-4 stick-right">
                  <label className="p-col-12 p-md-12" htmlFor="issuedFrom">
                    {t("issuingAuthorityPlace")}*
                  </label>
                  <Controller
                    name="issuedFrom"
                    control={control}
                    rules={{
                      required: "Issued From is required."
                    }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        id={field.name}
                        {...field}
                        value={p.issuedFrom}
                        filter showClear
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          setIssuedFrom(e.target.value);
                          setIssuedFromDesc(
                            e.originalEvent.nativeEvent.target.ariaLabel
                          );
                          dispatch(
                            setGuardianDocumentValue({
                              code: p.documentTypeId,
                              key: "issuedFrom",
                              value: e.target.value,
                            })
                          );
                        }}
                        options={issuedFromList}
                        optionLabel={(data) =>
                          getTValue(i18n, data.descEng, data.descNep)
                        }
                        placeholder={t("selectDistrict")}
                        optionValue="code"
                      />
                    )}
                  />
                  <span style={{ color: "red" }}>{issuedFromError}</span>
                  {getFormErrorMessage("issuedFrom")}{" "}
                </div>}

                {/* {(
                    documentMetadata.docId && (
                      <div
                        className={
                          "p-field p-col-12 p-md-4 stick-right"
                        }
                      >
                        <label className="p-col-12 p-md-12" htmlFor="docId">
                          {documentMetadata.docId
                            ? getTValue(
                              i18n,
                              documentMetadata.docId.labelEng,
                              documentMetadata.docId.labelNep
                            )
                            : t("docId")}
                          *
                        </label>
                        <Controller
                          name="docId"
                          control={control}
                          rules={{
                            ...(documentMetadata.docId.mandatory
                              ? { required: "Document Id is required." }
                              : {}),
                            ...(documentMetadata.docId.regex
                              ? {
                                pattern: {
                                  value: new RegExp(
                                    p.documentMetadata.docId.regex
                                  ),
                                  message: "Provide valid document id",
                                },
                              }
                              : {}),
                          }}
                          render={({ field, fieldState }) => (
                            <div className="p-inputgroup">
                              <InputText
                                id={field.name}
                                {...field}
                                value={p.docId}
                                clearSpace
                                keyFilter="alphanum"
                                placeholder={documentMetadata.docId
                                  ? getTValue(
                                    i18n,
                                    documentMetadata.docId.labelEng,
                                    documentMetadata.docId.labelNep
                                  )
                                  : t("docId")}
                                onChange={(e) => {
                                  field.onChange(e.target.value);
                                  // setDocId(e.target.value);
                                  dispatch(
                                    setGuardianDocumentValue({
                                      code: p.documentTypeId,
                                      key: "docId",
                                      value: e.target.value,
                                    })
                                  );
                                }}
                                className={classNames({
                                  "p-invalid": fieldState.invalid,
                                })}
                              />
                            </div>
                          )}
                        />
                        {getFormErrorMessage("docId")}
                      </div>
                    ))}

                  {!['NID', 'GNID'].includes(p.documentTypeId) && documentMetadata.issuedDateBs && (
                    <div className="p-field p-col-12 p-md-4 stick-left stick-right">
                      <label
                        className="p-col-12 p-md-12"
                        htmlFor="issuedDateBs"
                      >
                        {documentMetadata.issuedDateBs
                          ? getTValue(
                            i18n,
                            documentMetadata.issuedDateBs.labelEng,
                            documentMetadata.issuedDateBs.labelNep
                          )
                          : t("issuedDateBs")}{" "}
                        {documentMetadata.issuedDateBs.mandatory && "*"}
                      </label>

                      <span className="p-input-icon-right">
                        <i className="pi pi-calendar icon-front" />
                        <NepaliDatePicker2
                          inputClassName="form-control p-inputtext p-component p-filled"
                          value={p.issuedDateBs}
                          onChange={(value) => {
                            // setValue("issuedDate", issuedDate);
                            //   clearErrors("issuedDate");
                            setIssuedDateBs(value);
                            dispatch(
                              setGuardianDocumentValue({
                                code: p.documentTypeId,
                                key: "issuedDateBs",
                                value: value,
                              })
                            );
                            const checkDate = isValidDate(value);
                            if (checkDate) {
                              const convertedBsDate = bsToAd(value);
                              setIssuedDate(convertedBsDate);
                              dispatch(
                                setGuardianDocumentValue({
                                  code: p.documentTypeId,
                                  key: "issuedDate",
                                  value: convertedBsDate,
                                })
                              );
                            }
                          }}
                        />
                      </span>
                    </div>
                  )}
                  {getFormErrorMessage("issuedDateBs")}
                  {!['NID', 'GNID'].includes(p.documentTypeId) && documentMetadata.issuedDate && (
                    <div className="p-field p-col-12 p-md-4  stick-left">
                      <label className="p-col-12 p-md-12" htmlFor="issuedDate">
                        {documentMetadata.issuedDate
                          ? getTValue(
                            i18n,
                            documentMetadata.issuedDate.labelEng,
                            documentMetadata.issuedDate.labelNep
                          )
                          : t("issuedDateAd")}
                        {documentMetadata.issuedDate.mandatory && "*"}
                      </label>
                      <span className="p-input-icon-right">
                        <i className="pi pi-calendar icon-front" />

                        <Controller
                          name="issuedDate"
                          control={control}
                          rules={{
                            ...(documentMetadata.issuedDate.mandatory
                              ? { required: "Issued Date is required." }
                              : {}),
                          }}
                          render={({ field, fieldState }) => (
                            <CalendarAD
                              id={field.name}
                              {...field}
                              className={classNames({
                                "p-invalid": fieldState.invalid,
                              })}
                              placeholder={documentMetadata.issuedDate
                                ? getTValue(
                                  i18n,
                                  documentMetadata.issuedDate.labelEng,
                                  documentMetadata.issuedDate.labelNep
                                )
                                : t("issuedDateAd")}
                              readOnlyInput
                              value={new Date(p.issuedDate)}
                              onChange={(e) => {
                                const date = e.value;
                                setIssuedDate(date.toISOString().split("T")[0]);
                                field.onChange(
                                  date.toISOString().split("T")[0]
                                );
                                dispatch(
                                  setGuardianDocumentValue({
                                    code: p.documentTypeId,
                                    key: "issuedDate",
                                    value: date.toISOString().split("T")[0],
                                  })
                                );
                                const convertedAdDate = adToBs(
                                  new Date(
                                    date.getTime() -
                                    date.getTimezoneOffset() * 60000
                                  )
                                    .toISOString()
                                    .split("T")[0]
                                );
                                setIssuedDateBs(convertedAdDate);

                                dispatch(
                                  setGuardianDocumentValue({
                                    code: p.documentTypeId,
                                    key: "issuedDateBs",
                                    value: convertedAdDate,
                                  })
                                );
                              }}
                              monthNavigator
                              yearNavigator
                              yearRange={"1900 : " + new Date().getFullYear()}
                              dateFormat="yy-mm-dd"
                            />
                          )}
                        />
                      </span>
                      {getFormErrorMessage("issuedDate")}
                    </div>
                  )}

                  {!['NID', 'GNID'].includes(p.documentTypeId) && documentMetadata.issuedFrom && (
                    <div className="p-field p-col-12 p-md-4 stick-right">
                      <label className="p-col-12 p-md-12" htmlFor="issuedFrom">
                        {documentMetadata.issuedFrom
                          ? getTValue(
                            i18n,
                            documentMetadata.issuedFrom.labelEng,
                            documentMetadata.issuedFrom.labelNep
                          )
                          : t("issuingAuthorityPlace")}
                        {documentMetadata.issuedFrom.mandatory && "*"}
                      </label>
                      <Controller
                        name="issuedFrom"
                        control={control}
                        rules={{
                          ...(documentMetadata.issuedFrom.mandatory
                            ? { required: "Issued From is required." }
                            : {}),
                          ...(documentMetadata.issuedFrom.regex
                            ? {
                              pattern: {
                                value: new RegExp(
                                  documentMetadata.issuedFrom.regex
                                ),
                                message: "Invalid issuing authority place",
                              },
                            }
                            : {}),
                        }}
                        render={({ field, fieldState }) => (
                          <Dropdown
                            id={field.name}
                            {...field}
                            value={p.issuedFrom}
                            filter showClear
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              setIssuedFrom(e.target.value);
                              setIssuedFromDesc(
                                e.originalEvent.nativeEvent.target.ariaLabel
                              );
                              dispatch(
                                setGuardianDocumentValue({
                                  code: p.documentTypeId,
                                  key: "issuedFrom",
                                  value: e.target.value,
                                })
                              );
                            }}
                            options={districtList}
                            optionLabel={(data) =>
                              getTValue(i18n, data.descEng, data.descNep)
                            }
                            placeholder={documentMetadata.issuedFrom
                              ? getTValue(
                                i18n,
                                documentMetadata.issuedFrom.labelEng,
                                documentMetadata.issuedFrom.labelNep
                              )
                              : t("selectDistrict")}
                            optionValue="code"
                          />
                        )}
                      />
                      {getFormErrorMessage("issuedFrom")}{" "}
                    </div>
                  )} */}
              </div>}
              <DocumentUpload
                document={p}
                onUpload={(data) => {
                  dispatch(
                    setGuardianDocumentValue({
                      code: p.documentTypeId,
                      key: "fileId",
                      value: data.storageFileName,
                    })
                  );
                  dispatch(
                    setGuardianDocumentValue({
                      code: p.documentTypeId,
                      key: "fileName",
                      value: data.originalName,
                    })
                  );
                }}
                onUploadBack={(data) => {
                  dispatch(
                    setGuardianDocumentValue({
                      code: p.documentTypeId,
                      key: "backFileId",
                      value: data.storageFileName,
                    })
                  );
                  dispatch(
                    setGuardianDocumentValue({
                      code: p.documentTypeId,
                      key: "backFileName",
                      value: data.originalName,
                    })
                  );
                }}
              />
              <span style={{ color: "red" }}>{fileIdError}</span>
              <span style={{ color: "red", marginLeft: "250px" }}>{backFileIdError}</span>
            </div>
          ))}

        <DynamicFieldSection />
      </div>
    </Card>
  );
}

export default GuardianDetails;
